<template>


<div id="weekly-releases-section" class="container-fluid releases no-gutters">
  <div class="container-fluid container-weekly">

        <div class="row flowplayereleases" id="releases-ax" v-for="(cat,ic) in $parent.lang.movies" v-if="cat.movies.length > 0 && ic == 'featured' " v-bind:key="cat.genre">
           <h3 class="nrlslstxt text-center w-100" v-html="cat.genre"></h3>


              <a
                  v-scroll="handleScroll"
                  v-for="(movie,mic) in filterSlider(cat.movies)"
                  :key="mic"
                  :id="'weekly-release-'+movie.slug"
                  :ref="movie.slug"
                  :href="'/'+titleUrl(movie)"
                  :title="movie.title"
                  :alt="movie.title"
                  class="special-banner col-xs-12 col-sm-12 col-md-4" :style="'background: url('+$parent.img(movie.promo_background)+');'">

                <div class="blackplace text-center">
                  <img
                      v-lazyload
                      class="logo-compo-img"
                      width="365" height="202"
                      :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')"
                      :data-src="$parent.img(movie.promo_logo)"
                      :alt="(movie.title_keywords ? movie.title_keywords : movie.title)" >
                  <div class="container rela">

                    <p class="shortdesc">
                      {{movie.short_synopsis}}
                    </p>

                    <a
                        :href="'/'+titleUrl(movie)"
                        class="btn btn-sm btn-danger read-more btn-flg glow m1">{{$parent.lang.viewdetail}}</a>

                  </div>
                </div>


              </a>

        </div>

    </div>
  </div>


</template>


<script>




export default {
  name: 'flixSample',
  components: {
  },
  data(){ return {
      timer: null,
      prevPos: 0,
      direction: "even"
    }
  },
  created: function () {

    // this.lang = lang.es;
    // this.movies = lang.movies;
    
  },
  updated: function(){
    // this.profiling();
    this.fillScrollElements()
  },
  computed:{

    scrollElements: function() {
      let elems = []
      var i = 0
      Object.keys(this.$refs).forEach(el => {
        elems[i] = this.$refs[el][0]
        i++
      });
      return elems
    }

  },
  
  methods:{
    titleUrl: function(movie){
      let url = "";

      switch (movie.type) {
        case 'movie':
        case 'movies':
          url = (this.$parent.currentLang === 'es' ? 'peliculas' : 'movies' )+"/"+movie.slug;
          break;
        case 'series':
          url = "series/"+(this.$parent.currentLang === 'es' ? movie.slug : movie.slug+'/en/' );
        break;
        default:
          url = 'title'+movie.slug;
      }

      return url;
    },
    hasPromo: function(movie){
      return (movie.promo_logo && movie.promo_background ? movie : null)
    },
    filterSlider: function(movies){
      return movies.filter(this.hasPromo).slice(0,3)
    },
    handleScroll: function() {
      // if (this.$parent.isMobile){
      //   if (window.scrollY > this.prevPos){
      //     this.direction = "up"
      //   }else if (window.scrollY < this.prevPos){
      //     this.direction = "down"
      //   }else if (window.scrollY == this.prevPos){
      //     this.direction = "even"
      //   }
      //
      //
      //   let nextElement =  this.nextElement((window.scrollY - window.innerHeight), this.direction)
      //
      //
      //
      //   if (nextElement && this.direction != "even"  && window.scrollY > (window.innerHeight / 2)) {
      //
      //     clearTimeout(this.timer)
      //     this.timer = setTimeout(()=>{
      //       location.hash = "#"+nextElement.id
      //       // window.scrollTo({
      //       //   top: nextElement.offsetTop + window.innerHeight,
      //       //   left: 0,
      //       //   behavior: 'smooth'
      //       // });
      //       clearTimeout(this.timer)
      //       setTimeout(()=>{clearTimeout(this.timer)},410)
      //
      //     },400)
      //   }else{
      //     // clearTimeout(this.timer)
      //     // setTimeout(()=>{clearTimeout(this.timer);console.log("clear timer")},50)
      //   }
      //
      //   this.prevPos = window.scrollY
      //
      // }
    },
    fillScrollElements: function(){
      this.scrollElements = []
      Object.keys(this.$refs).forEach(el => {
        this.scrollElements.push(this.$refs[el][0].offsetTop)
      });
    },
    nextElement: function(t,dir){
      let result = this.scrollElements.filter(obj => {
        window._el = obj
        let ans = null
        switch (dir) {
          case "up":
            // ans = obj.offsetTop > t
            ans = null
            break;
          case "down":
            ans = obj.offsetTop < t
            break;
          case "even":
          default:

            ans = null
            break;

        }
        return ans
      })
      let first;
      switch (dir) {
        case "up":
          first = result.find((e)=>{return e})
          break;
        case "down":
          result.shift()
          first = result.find((e)=>{return e}) // last
          break;
        default:

          break;

      }

      return (first ? first : null);

    }

    

  }
  
}
</script>

<style lang="css">
.nav-pills .nav-link.active, .nav-pills .show>.nav-link{
  background-color: #d52027;
}

a.special-banner:hover{
  text-decoration: none;
  color: #ffffff;
}

.special-banner .logo-compo-img {
  height: auto;
  max-width: 70%;
  position: absolute;
  bottom: 0;
  left: 15%;
}
.special-banner .shortdesc{
  display: none;
}
.special-banner .read-more{
  display: none;
}

@media only screen
and (min-width: 200px)
and (max-width: 767px) {
  .special-banner{
    height: auto;
    padding-bottom: 3em;
  }
  .special-banner .blackplace{
    margin-top: 30vh;
  }
  .special-banner .logo-compo-img{
    width: 90%;
    margin: 0 5%;
    height: auto;
    position: inherit;
  }
  .special-banner .shortdesc{
    text-shadow: 2px 2px 6px #000;
    font-size: 1em;
    line-height: 1.4em;
    display: block;
  }
  .special-banner .read-more{
    display: block;
  }
}

/* Portrait
 and (min-device-width: 320px)
and (max-device-width: 667px)
 */
@media only screen
and (min-device-width: 200px)
and (max-device-width: 767px)
and (-webkit-min-device-pixel-ratio: 2)
and (orientation: portrait) {

  .special-banner{
    height: auto;
    padding-bottom: 3em;
  }
  .special-banner .blackplace{
    margin-top: 30vh;
  }
  .special-banner .logo-compo-img{
    width: 90%;
    margin: 0 5%;
    height: auto;
    position: inherit;
  }
  .special-banner .shortdesc{
    text-shadow: 2px 2px 6px #000;
    font-size: 1em;
    line-height: 1.4em;
    display: block;
  }
  .special-banner .read-more{
    display: block;
  }

}

/* Landscape */
@media only screen
and (min-device-width: 200px)
and (max-device-width: 812px)
and (-webkit-min-device-pixel-ratio: 2)
and (orientation: landscape) {

  .special-banner{
    background-repeat: no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
    background-color: red !important;
  }
  .special-banner .logo-compo {
    width: 100%;
    margin-top: 20%;
  }
  .special-banner .logo-compo-img{
    width: 50%;
    margin: 0 5%;
    height: auto;
    position: inherit;
  }
  .special-banner .shortdesc{
    text-shadow: 2px 2px 6px #000;
    font-size: 1em;
    line-height: 1.4em;
    /*display: block;*/
  }

}


@media only screen
and (min-device-width: 375px)
and (max-device-width: 812px)
and (-webkit-min-device-pixel-ratio: 3)
and (orientation: portrait) {
  .special-banner .blackplace{
    margin-top: 30vh;
  }
  .special-banner .logo-compo-img{
    width: 90%;
    margin: 0 5%;
    height: auto;
    position: inherit;
  }
  .special-banner .shortdesc{
    text-shadow: 2px 2px 6px #000;
    font-size: 1em;
    line-height: 1.4em;
    display: block;
  }
  .special-banner .read-more{
    display: block;
  }
}


/* Landscape */
@media only screen
and (min-device-width: 375px)
and (max-device-width: 812px)
and (-webkit-min-device-pixel-ratio: 3)
and (orientation: landscape) {
  .special-banner{
    background-repeat: no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
    padding: 2em 0;
  }
  .special-banner .logo-compo {
    width: 100%;
    margin-top: 20%;
  }
  .special-banner .logo-compo-img{
    width: 50%;
    margin: 0 5%;
    height: auto;
    position: inherit;
  }
  .special-banner .shortdesc{
    text-shadow: 2px 2px 6px #000;
    font-size: 1em;
    line-height: 1.4em;
    /*display: block;*/
  }
}


/* ----------- iPad 1, 2, Mini and Air ----------- */

/* Portrait and Landscape */
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (-webkit-min-device-pixel-ratio: 1) {

}

/* Portrait */
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 1) {

}

/* Landscape */
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: landscape)
and (-webkit-min-device-pixel-ratio: 1) {

}

/* ----------- iPad 3, 4 and Pro 9.7" ----------- */

/* Portrait and Landscape */
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (-webkit-min-device-pixel-ratio: 2) {
  .special-banner{
    height: 190px;
  }
}

/* Portrait */
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 2) {

}

/* Landscape */
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: landscape)
and (-webkit-min-device-pixel-ratio: 2) {
  .special-banner{
    height: 190px;
  }
}

/* ----------- iPad Pro 10.5" ----------- */

/* Portrait and Landscape */
@media only screen
and (min-device-width: 834px)
and (max-device-width: 1112px)
and (-webkit-min-device-pixel-ratio: 2) {

}

/* Portrait */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen
and (min-device-width: 834px)
and (max-device-width: 834px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 2) {

}

/* Landscape */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen
and (min-device-width: 1112px)
and (max-device-width: 1112px)
and (orientation: landscape)
and (-webkit-min-device-pixel-ratio: 2) {
  .special-banner{
    height: 190px;
  }

}

/* ----------- iPad Pro 12.9" ----------- */

/* Portrait and Landscape */
@media only screen
and (min-device-width: 1024px)
and (max-device-width: 1366px)
and (-webkit-min-device-pixel-ratio: 2) {

}

/* Portrait */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen
and (min-device-width: 1024px)
and (max-device-width: 1024px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 2) {

}

/* Landscape */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen
and (min-device-width: 1366px)
and (max-device-width: 1366px)
and (orientation: landscape)
and (-webkit-min-device-pixel-ratio: 2) {
  .special-banner{
    height: 250px;
  }

}
</style>